export const initTwingle = () => {
    var _a;
    const sections = document.querySelectorAll('[data-iframe-src], [data-html-embed]');
    if (!sections.length)
        return;
    const cookieBanner = document.querySelector('.cookie-banner');
    const cookieButton = document.querySelector('.cookie-button');
    for (const section of sections) {
        const src = section.dataset.iframeSrc;
        const isHtmlEmbed = section.dataset.htmlEmbed === 'true';
        const style = section.dataset.iframeStyle || '';
        const cookieId = section.dataset.iframeCookieId || "twingle-id" /* COOKIES.TWINGLE */;
        // Cookie Layer appends "-id" to its backend key. Accept the duplicated
        // suffix as well, so an accidentally entered "social-network-id" key
        // still grants consent via "social-network-id-id".
        const hasConsent = () => localStorage.getItem(cookieId) === 'true' ||
            localStorage.getItem(`${cookieId}-id`) === 'true';
        if (!src && !isHtmlEmbed)
            continue;
        const wrapper = section.querySelector('.iframe-wrapper');
        const htmlWrapper = section.querySelector('.social-network-embed-wrapper');
        const embedTemplate = section.querySelector('.social-network-embed-template');
        const placeholder = section.querySelector('.open-cookie-wrapper-twingle');
        if ((!wrapper && !htmlWrapper) || !placeholder)
            continue;
        let iframeLoaded = false;
        const showIframe = () => {
            placeholder.style.display = 'none';
            if (htmlWrapper && embedTemplate) {
                htmlWrapper.style.display = '';
                if (!htmlWrapper.childNodes.length) {
                    htmlWrapper.appendChild(embedTemplate.content.cloneNode(true));
                }
                return;
            }
            wrapper.style.display = '';
            if (!iframeLoaded) {
                const iframe = wrapper.querySelector('iframe');
                if (src)
                    iframe.src = src;
                if (style)
                    iframe.setAttribute('style', style);
                iframeLoaded = true;
            }
        };
        const showPlaceholder = () => {
            if (wrapper)
                wrapper.style.display = 'none';
            if (htmlWrapper)
                htmlWrapper.style.display = 'none';
            placeholder.style.display = '';
        };
        (_a = placeholder.querySelector('.open-cookie')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', (e) => {
            e.preventDefault();
            cookieBanner.classList.add('active');
            cookieButton.classList.remove('active');
        });
        if (hasConsent()) {
            showIframe();
        }
        else {
            showPlaceholder();
        }
        document.addEventListener("cookiesUpdated" /* EVENTS.COOKIES_UPDATED */, () => {
            if (hasConsent()) {
                showIframe();
            }
            else {
                showPlaceholder();
            }
        });
    }
};
